export default __webpack_public_path__ + "static/media/Lacey 9781408336786.6629e642.jpg";